/**
 * O resultado auditado do caso, inteiro (E153.F3, GUS-176, ADR-0104 §2.6): o resumo da
 * conferência, as informações aos compositores, a matriz pública com o estado interno por expansão,
 * os achados com destino, os artefatos registrados e o contrato por expansão. A página mostra o que
 * `GET /casos/{id}/resultado` devolve; não decide nem registra.
 */
import type { ResultadoDoCasoData } from '@/lib/resultadoAuditado';

import { AchadosDoResultado } from './AchadosDoResultado';
import { ArtefatosDoResultado } from './ArtefatosDoResultado';
import { ContratoJson } from './ContratoJson';
import { InformacoesAosCompositores } from './InformacoesAosCompositores';
import { MatrizPublicaDoResultado } from './MatrizPublicaDoResultado';
import { ResumoDoResultado } from './ResumoDoResultado';
import { t } from './textos';

export function ResultadoAuditado({ dados }: { dados: ResultadoDoCasoData }): JSX.Element {
  return (
    <div
      className="space-y-sc-6"
      data-testid="resultado-auditado"
      data-situacao={dados.situacao}
      data-consumivel={dados.consumivel}
    >
      <ResumoDoResultado dados={dados} />
      <InformacoesAosCompositores dados={dados} />
      {dados.resultado !== null ? (
        <>
          <MatrizPublicaDoResultado resultado={dados.resultado} />
          <AchadosDoResultado achados={dados.resultado.achados} />
        </>
      ) : null}
      <ArtefatosDoResultado artefatos={dados.artefatos} />
      <ContratoJson dados={dados} />
      <p className="max-w-prose text-caption text-fg-muted" data-testid="resultado-limite">
        {t.limite}
      </p>
    </div>
  );
}
